var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container mt-5"},[_vm._v("Please wait...")])
}
var staticRenderFns = []

export { render, staticRenderFns }